import { ReactElement } from 'react';
import Dropzone from 'react-dropzone';
import { ICustomDropzoneProps } from './CustomDropzone-type';

export const CustomDropzone = (props: ICustomDropzoneProps): ReactElement => {
  const DropzoneElement: any = Dropzone;

  return <DropzoneElement {...props} />;
};
